/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST

export const queryProjectTaskPackageProjects = params => {
  return axios.post(`${base}/query_project_task_package_projects`, params)
}

export const getProjectTaskPackageConfig = params => {
  return axios.get(`${base}/project-task-package/config_${params.projectId || params.id}`)
}

export const saveProjectTaskPackageConfig = params => {
  const projectId = params.projectId || params.id
  return axios.post(`${base}/project-task-package/save_config_${projectId}`, params)
}

export const queryProjectTaskPackageFlag = params => {
  return axios.post(`${base}/project_task_package_flag/query`, params || {})
}

export const createProjectTaskPackageFlag = params => {
  return axios.post(`${base}/project_task_package_flag/create`, params)
}

export const deleteProjectTaskPackageFlag = params => {
  return axios.post(`${base}/project_task_package_flag/delete_${params.id}`)
}



// WEBPACK FOOTER //
// ./src/views/project-task-package/project-task-package.api.js